



























































































































import {Component} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {LongTextWings} from '@/components';
import MailNotifyDetailFilter from '@/components/MailNotify/MailNotifyDetailFilter.vue';
import ScrollButton from "@/components/ScrollButton.vue";
import {dateFilter} from "@/utils/date-util";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { DetailItem } from "@/store/mailnotify/statistic/types";

@Component({ components: {MailNotifyDetailFilter, ScrollButton, LongTextWings}, filters: {dateFilter} })
export default class MailNotifyDetail extends BaseItemsPage<DetailItem> {

  @Getter("mnStatisticDetail") responseItems: any;

  is_show_filter_additional = false;
  currentSort = "create_date";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return [
      "create_date",
      "mn_service_name",
      "mn_tmpl",
      "routes",
      "recipient",
      "message",
      "status",
      "partner_price",
      "detail"
    ];
  }

  getData() {
    return this.responseItems;
  }

}
